function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck
import React from 'react';
import { IndexPath } from "../../devsupport";
const SEPARATOR = ', ';
export class SelectService {
  constructor() {
    _defineProperty(this, "selectItem", (multiSelect, descriptor, selected) => {
      if (multiSelect) {
        return this.createMultiSelectIndices(descriptor, selected);
      }

      return descriptor.index;
    });

    _defineProperty(this, "toStringSelected", selected => {
      if (!Array.isArray(selected)) {
        return '';
      }

      const options = selected.map(index => {
        return `Option ${index.toString()}`;
      });
      return options.join(SEPARATOR);
    });

    _defineProperty(this, "isSelected", (descriptor, selected) => {
      if (descriptor.multiSelect && this.isGroup(descriptor)) {
        return this.containsSomeFromGroup(descriptor.index, selected);
      }

      return this.contains(descriptor.index, selected);
    });

    _defineProperty(this, "isDisabled", descriptor => {
      return !descriptor.multiSelect && this.isGroup(descriptor);
    });

    _defineProperty(this, "createDescriptorForElement", (element, multiSelect, index) => {
      const groupIndices = React.Children.map(element.props.children, (child, row) => {
        return new IndexPath(row, index);
      });
      return {
        multiSelect,
        groupIndices,
        index: new IndexPath(index)
      };
    });

    _defineProperty(this, "createDescriptorForNestedElement", (element, descriptor, index) => {
      return _objectSpread(_objectSpread({}, descriptor), {}, {
        index: new IndexPath(index, descriptor.index.row),
        groupIndices: []
      });
    });

    _defineProperty(this, "createMultiSelectIndices", (descriptor, selected) => {
      const isIndexSelected = this.isSelected(descriptor, selected);
      return !isIndexSelected ? this.addIndex(descriptor, selected) : this.removeIndex(descriptor, selected);
    });

    _defineProperty(this, "isGroup", descriptor => {
      return descriptor.groupIndices && descriptor.groupIndices.length > 0;
    });

    _defineProperty(this, "createGroupIndices", descriptor => {
      return this.isGroup(descriptor) ? descriptor.groupIndices : [descriptor.index];
    });

    _defineProperty(this, "addIndex", (descriptor, selected) => {
      return [...selected, ...this.createGroupIndices(descriptor)];
    });

    _defineProperty(this, "removeIndex", (descriptor, selected) => {
      const groupIndices = this.createGroupIndices(descriptor);
      return selected.filter(selectedIndex => {
        return !this.contains(selectedIndex, groupIndices);
      });
    });

    _defineProperty(this, "contains", (index, selected) => {
      return selected.some(selectedIndex => {
        return selectedIndex.equals(index);
      });
    });

    _defineProperty(this, "containsSomeFromGroup", (index, selected) => {
      return selected.some(selectedIndex => {
        return selectedIndex.section === index.row;
      });
    });
  }

}